import { FHIR_API } from '@/constants/api-endpoints.constants';
import axiosInstance from './config';
import axios, { AxiosRequestConfig } from 'axios';
import storageService from '../storage-service';

export const postData = async <T>(
  urlEndpoint: string,
  data: T,
  config?: AxiosRequestConfig
) => {
  try {
    const response = await axiosInstance.post(urlEndpoint, data, config);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getData = async (urlEndpoint: string) => {
  try {
    const response = await axiosInstance.get(urlEndpoint);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const putData = async <T>(
  urlEndpoint: string,
  data: T,
  config?: AxiosRequestConfig
) => {
  try {
    const response = await axiosInstance.put(urlEndpoint, data, config);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const patchData = async <T>(
  urlEndpoint: string,
  data: T,
  config?: AxiosRequestConfig
) => {
  try {
    const response = await axiosInstance.patch(urlEndpoint, data, config);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const deleteData = async <T>(urlEndpoint: string, data?: T) => {
  try {
    const response = await axiosInstance.delete(urlEndpoint, {
      headers: {},
      data,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

// Helper function to handle errors
const handleError = (error: unknown) => {
  if (axios.isAxiosError(error)) {
    console.error(
      `API Error: ${error.response?.status} - ${error.response?.data?.message}`
    );
  } else {
    console.error('Unexpected Error: ', error);
  }
  throw error;
};

export const fhirAPI = axios.create({
  baseURL: FHIR_API,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
fhirAPI.interceptors.request.use((config: any) => {
  return {
    ...config,
    headers: {
      ...config.headers,
      Authorization: `Bearer ${storageService.getAccessToken()}`,
      'Content-Type': 'application/json',
    },
  };
});
